import type { OpportunityStatus } from '@swf/core/models/sports/types/betSlip';
import { RunnerStatus } from '@swf/sports/types/runner';

const runnerStatusMap: Record<OpportunityStatus, RunnerStatus> = {
  AVAILABLE: RunnerStatus.ACTIVE,
  SUSPENDED: RunnerStatus.SUSPENDED,
  UNAVAILABLE: RunnerStatus.REMOVED
};

const getRunnerStatus = (status: OpportunityStatus): RunnerStatus => runnerStatusMap[status];

export default getRunnerStatus;
